import { render } from "./Main.vue?vue&type=template&id=52ea3e45"
const script = {}
script.render = render

export default script